import { createFileRoute, useLocation } from '@tanstack/react-router';
import { CheckInboxPage } from '../pages/CheckInboxPage';

type CheckInboxState = {
  email?: string;
  reason?: 'verify' | 'magic-link';
};

export const Route = createFileRoute('/check-inbox')({
  component: RouteComponent,
});

function RouteComponent() {
  const location = useLocation();
  const { email, reason } = (location.state as CheckInboxState) ?? {};
  return <CheckInboxPage email={email} reason={reason} />;
}
